const CHANNEL_NAME = 'petrovich-web-sync';
const STORAGE_EVENT_KEY = 'petrovich:sync-event';

let channel = null;

function canUseBroadcastChannel() {
  return typeof window !== 'undefined' && typeof window.BroadcastChannel !== 'undefined';
}

export function publishSyncEvent(type, payload = {}) {
  const event = {
    type,
    payload,
    ts: Date.now(),
  };

  if (canUseBroadcastChannel()) {
    if (!channel) {
      channel = new window.BroadcastChannel(CHANNEL_NAME);
    }
    channel.postMessage(event);
  }

  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    window.localStorage.setItem(STORAGE_EVENT_KEY, JSON.stringify(event));
    window.localStorage.removeItem(STORAGE_EVENT_KEY);
  }
}

export function subscribeSyncEvents(handler) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const onBroadcast = (event) => handler(event.data);
  const onStorage = (event) => {
    if (event.key !== STORAGE_EVENT_KEY || !event.newValue) {
      return;
    }

    try {
      handler(JSON.parse(event.newValue));
    } catch (error) {
      console.error('Failed to parse sync event', error);
    }
  };

  if (canUseBroadcastChannel()) {
    if (!channel) {
      channel = new window.BroadcastChannel(CHANNEL_NAME);
    }
    channel.addEventListener('message', onBroadcast);
  }

  window.addEventListener('storage', onStorage);

  return () => {
    if (channel) {
      channel.removeEventListener('message', onBroadcast);
    }
    window.removeEventListener('storage', onStorage);
  };
}
